import {
  displayQty,
  displayUnit,
  fmtMoney,
  fmtNumber,
  priceUnit,
} from '../../data/format';

/** '70,000 ft' for wire (700 C), '60 each', '22 h'. */
export function qtyText(quantity: number, unit: string): string {
  return `${fmtNumber(displayQty(quantity, unit))} ${displayUnit(unit)}`;
}

/** What a price is per, in words: 'per 100 ft', 'per month', 'each'. */
export function perUnitText(unit: string): string {
  return unit === 'each' ? 'each' : `per ${priceUnit(unit)}`;
}

/** '$431.50 per 100 ft', '$5,500.00 each', '$30,000.00 per month' (always cents). */
export function pricePerText(price: number, unit: string): string {
  return `${fmtMoney(price, { cents: true })} ${perUnitText(unit)}`;
}

/** Compact form for table cells: '$431.50 / 100 ft', '$30,000.00 / month'. */
export function priceSlashText(price: number, unit: string): string {
  const money = fmtMoney(price, { cents: true });
  return unit === 'each' ? money : `${money} / ${priceUnit(unit)}`;
}
